import { render, staticRenderFns } from "./Gad2.vue?vue&type=template&id=7abfb48c&scoped=true&"
import script from "./Gad2.vue?vue&type=script&lang=ts&"
export * from "./Gad2.vue?vue&type=script&lang=ts&"
import style0 from "./Gad2.vue?vue&type=style&index=0&id=7abfb48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abfb48c",
  null
  
)

export default component.exports